import React, { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";
import AgentOf from "../home/AgentOf";
import "../../../assets/style/components/pages/about/_aboutPage.scss";
import { generalServices } from "../../../services/GeneralServices";
import MainLoader from "../../blocks/MainLoader";
import Global from "../../../language/Global.json";
import { setLanguage } from "../../../redux/actions-reducers/language";
import { setUser } from "../../../redux/actions-reducers/user";
import { connect } from "react-redux";
import { apiService } from "../../../services/ApiService";

class AboutPage extends Component {
    state = { pageData: {}, pageLoader: true, StaticImageData: {} };
    componentDidMount() {
        this.getPublicPageData();
        this.getStaticImage();
    }

    getPublicPageData = async () => {
        const { success, data } = await generalServices.getPublicPageData(
            this.props.match.params.machineName
        );

        if (!success) return;

        this.setState({
            pageData: data,
            pageLoader: false,
        });
    };

    getStaticImage = async () => {
        const { success, data } = await generalServices.getStaticImage(1);

        if (!success) return;

        this.setState({
            StaticImageData: data,
        });
    };

    render() {
        const { pageData, pageLoader, StaticImageData } = this.state;
        const {
            // i18n: {},
            language,
        } = this.props;

        return pageLoader ? (
            <MainLoader />
        ) : (
            <div
                className={`about-page contact-us ${
                    language === "ar" && "about-page-arabic"
                }`}
            >
                <div className="page-label" />
                <Container>
                    {/* page title start  */}
                    <h3 className="page-title">{pageData.title}</h3>
                    {/* page title end   */}

                    <Container
                        className={`about-page__about-passages-container ${
                            StaticImageData?.image
                                ? ""
                                : "about-page__about-passages-container-no-image"
                        } `}
                    >
                        <Row>
                            <Col sm={12} md={5}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: pageData.text,
                                    }}
                                />
                            </Col>
                            <Col sm={12} md={7}>
                                <img
                                    className={
                                        window.location.pathname ===
                                        "/PublicPage/about"
                                            ? ""
                                            : "image-display-none"
                                    }
                                    // src="/images/Pencils.png"
                                    src={
                                        apiService.imageLink +
                                        StaticImageData?.image
                                    }
                                    alt="1"
                                />
                            </Col>
                        </Row>
                        {/* main img start */}

                        {/* {console.log(
                            window.location.pathname,
                            "window.location.pathname"
                        )} */}
                        {/* main img end */}

                        {/* about page descriptions start  */}

                        {/*  <div className="about-page__first-article">
                           <h4>What is Lorem Ipsum?</h4>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
                                and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                            </p>
                        </div>
                        <h4>Why do we use it?</h4>
                        <p>
                            It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites
                            still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).
                        </p>
                        <h4>Where does it come from?</h4>
                        <p>
                            Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and
                            1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.
                        </p>
                        <p>The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonoru
                        m et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.<
                        /p> */}
                    </Container>
                    {/* about page descriptions end  */}

                    {/* <div
                        className={`about-page__about-passages-container ${
                            StaticImageData?.image
                                ? ""
                                : "about-page__about-passages-container-no-image"
                        } `}
                    >
                        <div className="about-page__about-passages__content d-flex justify-content-between align-items-center">
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: pageData.text,
                                }}
                            />
                            <img
                                className={
                                    window.location.pathname ===
                                    "/PublicPage/about"
                                        ? ""
                                        : "image-display-none"
                                }
                                // src="/images/Pencils.png"
                                src={
                                    apiService.imageLink +
                                    StaticImageData?.image
                                }
                                alt="1"
                            />
                        </div>
                    </div> */}
                </Container>
                <AgentOf />
            </div>
        );
    }
}

const mapStateToProps = ({ currentUser, language }) => ({
    language: language.lang,
    i18n: language.lang === "ar" ? Global.ar : Global.en,
    currentUser,
});

export default connect(mapStateToProps, { setUser, setLanguage })(AboutPage);
